import { api } from '../../api/client';
import type { FormacionPrecio, Params, TipoPublicacion } from './types';

// Calculadora y Publicaciones: la fórmula es la del backend (la misma de «Por publicación»).
// POST precios/simular sólo calcula: no guarda nada ni llama a MercadoLibre.

export const TIPOS_PUBLICACION: Array<{ id: TipoPublicacion; label: string }> = [
  { id: 'clasica', label: 'Clásica' },
  { id: 'premium', label: 'Premium' },
  { id: 'premium_pro', label: 'Premium Pro' },
];

export interface ItemSimulacion {
  /** Publicación de ML, si tiene: el backend usa su comisión real vigente. */
  mlaId?: string;
  costoConIva: number;
  pesoKg: number | null;
  tipo: TipoPublicacion;
  rentabilidadPct: number;
  precioActual: number | null;
}

/** Tope de ítems por pedido (backend: SimularPreciosDto). */
const MAX_ITEMS = 500;

/** Costo con IVA según el panel: el del catálogo ya lo trae, o se le suma el IVA del proveedor. */
export const costoConIvaSegun = (costo: number, p: Params) => (p.costoConIva ? costo : costo * (1 + p.ivaAlicuota / 100));

export async function simularPrecios(items: ItemSimulacion[]): Promise<FormacionPrecio[]> {
  const resultados: FormacionPrecio[] = [];
  for (let i = 0; i < items.length; i += MAX_ITEMS) {
    resultados.push(...await api.post<FormacionPrecio[]>('/api/v3/precios/simular', { items: items.slice(i, i + MAX_ITEMS) }));
  }
  return resultados;
}
